/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var processInclude = __webpack_require__(3);

	$(document).ready(function () {
	    processInclude(__webpack_require__(171));
	    processInclude(__webpack_require__(172));
	    processInclude(__webpack_require__(173));
	});

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

	'use strict';

	/**
	 * Remove all validation. Should be called every time before revalidating form
	 * @param {element} form - Form to be cleared
	 * @returns {void}
	 */

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	function clearFormErrors(form) {
	    $(form).find('.form-control.is-invalid').removeClass('is-invalid');
	}

	module.exports = function (formElement, payload) {
	    // clear form validation first
	    clearFormErrors(formElement);
	    $('.alert', formElement).remove();

	    if ((typeof payload === 'undefined' ? 'undefined' : _typeof(payload)) === 'object' && payload.fields) {
	        Object.keys(payload.fields).forEach(function (key) {
	            if (payload.fields[key]) {
	                var feedbackElement = $(formElement).find('[name="' + key + '"]').parents('.cc-form-group').find('.invalid-feedback');

	                if (feedbackElement.length > 0) {
	                    if (Array.isArray(payload[key])) {
	                        feedbackElement.find('.cc-text-message').html(payload.fields[key].join('<br/>'));
	                    } else {
	                        feedbackElement.find('.cc-text-message').html(payload.fields[key]);
	                    }
	                    feedbackElement.siblings('.form-control').addClass('is-invalid');
	                    feedbackElement.show();
	                    feedbackElement[0].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
	                }
	            }
	        });
	    }
	    if (payload && payload.error) {
	        var form = $(formElement).prop('tagName') === 'FORM' ? $(formElement) : $(formElement).parents('form');

	        form.prepend('<div class="alert alert-danger" role="alert">' + payload.error.join('<br/>') + '</div>');
	    }
	};

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	module.exports = function (include) {
	    if (typeof include === 'function') {
	        include();
	    } else if ((typeof include === 'undefined' ? 'undefined' : _typeof(include)) === 'object') {
	        Object.keys(include).forEach(function (key) {
	            if (typeof include[key] === 'function') {
	                include[key]();
	            }
	        });
	    }
	};

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var formValidation = __webpack_require__(1);
	// State checker to avoid multiple ajax calls when loading registration fields.
	var isLoadingRegistrationFields = false;

	/**
	 * Regex to check if the string passed is a valid e-mail address
	 */
	function isValidEmailAddress(emailAddressToValidate) {
	    var regexEmailString = /^[\w.%+-]+@[\w.-]+\.[\w]{2,6}$/;
	    return regexEmailString.test(emailAddressToValidate);
	}

	/**
	 * Validate email format and display error
	 * @param {*} field - the email field to validate
	 * @returns {Boolean} - a boolean that rapresent if the email inserted is valid or not
	 */
	function validateEmail(field) {
	    var isValid = isValidEmailAddress($(field).val());
	    if (isValid) {
	        $(field).removeClass('is-invalid custom-error');
	    } else {
	        $(field).addClass('is-invalid custom-error');
	        $(field).parents('.cc-form-group').find('.cc-text-message').text($(field).data('pattern-mismatch'));
	    }
	    return isValid;
	}

	/**
	 * Validate phone format and display error
	 * @param {*} field - the phone field to validate
	 * @returns {Boolean} - a boolean that rapresent if the number inserted is valid or not
	 */
	function validatePhone(field) {
	    var regexPhoneString = $(field).data('phone-pattern');
	    var regexPhone = new RegExp(regexPhoneString);
	    var isValid = regexPhone.test($(field).val().trim());
	    if (isValid) {
	        $(field).removeClass('is-invalid custom-error');
	    } else {
	        $(field).addClass('is-invalid custom-error');
	        $(field).parents('.cc-form-group').find('.cc-text-message').text($(field).data('pattern-phone-mismatch'));
	    }
	    return isValid;
	}

	/**
	 * Hide checkout login modal if present
	 */
	function hideCheckoutModal() {
	    if ($('#checkoutLoginModal').length > 0) {
	        $('#checkoutLoginModal').modal('hide');
	    }
	}

	/**
	 * Changes the login form into a form that contains notification about complete registration
	 * and on submit redirects to complete registration page
	 * @param {Object} data - Response data containing phone and notification template
	 */
	function showCompleteRegistrationRedirectNotification(data) {
	    // Remove existing notification if present
	    $('.cc-phone-registration-notification').remove();

	    // Hide login form elements only for login source (not checkout)
	    $('.cc-form-password').hide();
	    $('.cc-login-content-remember').hide();
	    $('button[type="submit"].cc-button-type-1').hide();

	    var $notification = $(data.notificationTemplate);

	    $('form.login').after($notification);
	}

	/**
	 * Open complete registration modal for login and checkout flows
	 * @param {Object} data - Response data containing phone and form configuration
	 */
	function openCompleteRegistrationModal(data) {
	    if (isLoadingRegistrationFields) {
	        return;
	    }

	    isLoadingRegistrationFields = true;
	    hideCheckoutModal();

	    if (data.completeRegistrationModalTemplate) {
	        // Remove existing modal if present
	        $('#completeRegistrationModal').remove();

	        // Append the modal template to body
	        $('body').append(data.completeRegistrationModalTemplate);

	        // Show the modal
	        $('#completeRegistrationModal').modal('show');

	        // Add modal-open class after modal is shown and ensure it stays
	        $('#completeRegistrationModal').on('shown.bs.modal', function () {
	            $('body').addClass('modal-open');
	        });

	        // Reset loading flag and unlock scroll when modal is closed
	        $('#completeRegistrationModal').on('hidden.bs.modal', function () {
	            isLoadingRegistrationFields = false;
	            $('body').removeClass('modal-open');
	        });
	    }
	}

	module.exports = {
	    login: function login() {
	        // FSP-40499 - Requirement
	        // Handling the submit event in a different way so it is equivalent with the as-is implementation and also
	        // covers the scenario in which the FE file is loaded through the script tag inside the pageHeader.isml template.
	        $(document).on('submit', 'form.login', function (e) {
	            var form = $(this);
	            e.preventDefault();
	            var url = form.attr('action');
	            var isEmailField = $('#login-form-email')[0].type === 'email' ? true : false;
	            if (!isEmailField) {
	                var isValid = false;
	                var numberRegex = /^\+?[\d ]+$/;
	                var isPhoneNumber = numberRegex.test($('#login-form-email').val().trim());
	                if (isPhoneNumber) {
	                    isValid = validatePhone($('#login-form-email'));
	                } else {
	                    isValid = validateEmail($('#login-form-email'));
	                }
	                if (!isValid) {
	                    return;
	                }
	            }
	            form.spinner().start();
	            $('form.login').trigger('login:submit', e);
	            $.ajax({
	                url: url,
	                type: 'post',
	                dataType: 'json',
	                data: form.serialize(),
	                success: function success(data) {
	                    form.spinner().stop();
	                    if (!data.success) {
	                        if (data.isFirstLogin) {
	                            $('#firstLoginModal').modal('show');
	                            // hide login modal on checkout to avoid modals overlap
	                            if ($('#checkoutLoginModal').length > 0) {
	                                $('#checkoutLoginModal').modal('hide');
	                            }
	                        } else {
	                            formValidation(form, data);
	                        }
	                        //update csrf token
	                        $('#csrfTokenInput').val(data.csrf.token);
	                        $('form.login').trigger('login:error', data);
	                    } else {
	                        var isLoginCheckout = $('#checkoutLoginModal').length > 0 ? true : false;
	                        $('form.login').trigger('login:success', data);
	                        // trigger the analytics login event
	                        var email = $('#login-form-email').val();
	                        var method = isValidEmailAddress(email) ? 'email' : 'telephone';
	                        $('body').trigger('analytics:login', {
	                            customerCrmId: data.customerCrmId,
	                            email: email,
	                            method: method,
	                            isLoginCheckout: isLoginCheckout
	                        });
	                        // trigger the analytics basket collection data for mailing list
	                        $('body').trigger('analytics:pushBasketData', data.gtmData);
	                        // Passing the user credentials to Reskyt (Login flow)
	                        var userCreds = {
	                            user: email,
	                            password: $('#login-form-password').val()
	                        };
	                        $('body').trigger('reskit:credentials_created', userCreds);
	                        if (data.tokenFPF && data.customerIdFPF && data.passwordResetOnLogin) {
	                            var redirect = $('<form>').appendTo(document.body).attr({
	                                method: 'POST',
	                                action: data.redirectUrl
	                            });
	                            $('<input>').appendTo(redirect).attr({
	                                name: 'token',
	                                value: data.tokenFPF
	                            });
	                            $('<input>').appendTo(redirect).attr({
	                                name: 'customerId',
	                                value: data.customerIdFPF
	                            });
	                            $('<input>').appendTo(redirect).attr({
	                                name: 'passwordResetOnLogin',
	                                value: data.passwordResetOnLogin
	                            });
	                            redirect.submit();
	                        } else if (form.attr('data-login-source') === 'promoBanner' || form.attr('data-login-source') === 'pdpPromotion') {
	                            // Promo Banner/ PDP Promotion Login button - reload the current page instead of redirecting away.
	                            location.reload();
	                        } else {
	                            location.href = data.redirectUrl;
	                        }
	                    }
	                },
	                error: function error(data) {
	                    if (data.responseJSON.redirectUrl) {
	                        window.location.href = data.responseJSON.redirectUrl;
	                    } else {
	                        $('form.login').trigger('login:error', data);
	                        form.spinner().stop();
	                    }
	                }
	            });
	            return false;
	        });
	    },

	    completeRegistration: function completeRegistration() {
	        $(document).on('submit', 'form.js-completeRegistration', function (e) {
	            e.preventDefault();
	            var form = $(this);
	            var url = form.attr('action');

	            form.spinner().start();
	            $.ajax({
	                url: url,
	                type: 'post',
	                dataType: 'json',
	                data: form.serialize(),
	                success: function success(data) {
	                    form.spinner().stop();
	                    if (!data.success) {
	                        formValidation(form, data);
	                    } else {
	                        // GA4 sign_up and login event - Trigger analytics events for in-store registration completion
	                        if (data.customerCrmId) {
	                            var identifier = $('#modal-phone-field').val();
	                            var method = isValidEmailAddress(identifier) ? 'email' : 'telephone';

	                            $('body').trigger('analytics:registration', {
	                                customerId: data.customerId,
	                                customerCrmId: data.customerCrmId,
	                                signupType: 'in store'
	                            });

	                            $('body').trigger('analytics:login', {
	                                customerCrmId: data.customerCrmId,
	                                method: method,
	                                loginType: 'in store'
	                            });
	                        }

	                        location.href = data.redirectUrl;
	                    }
	                },
	                error: function error(data) {
	                    form.spinner().stop();
	                    if (data.responseJSON && data.responseJSON.redirectUrl) {
	                        window.location.href = data.responseJSON.redirectUrl;
	                    }
	                }
	            });
	            return false;
	        });
	    },

	    resetPassword: function resetPassword() {
	        $('.reset-password-form').submit(function (e) {
	            var form = $(this);
	            e.preventDefault();
	            var url = form.attr('action');
	            form.spinner().start();
	            form.trigger('login:register', e);
	            $.ajax({
	                url: url,
	                type: 'post',
	                dataType: 'json',
	                data: form.serialize(),
	                success: function success(data) {
	                    form.spinner().stop();
	                    if (data.redirectUrl) {
	                        //close the modal and redirect to another
	                        form.closest('.modal-content').find('button.close').trigger('click');
	                        location.href = data.redirectUrl;
	                    } else if (!data.success) {
	                        // no migration needed
	                        formValidation(form, data);
	                    } else {
	                        $('.request-password-title').text(data.receivedMsgHeading);
	                        $('.request-password-body').empty().append('<p>' + data.receivedMsgBody + '</p><div class="cc-content-button-back"><a href="' + data.returnUrl + '" class="cc-button-type-1" id="submitEmailButton">' + data.buttonText + '</a></div>');
	                    }
	                },
	                error: function error() {
	                    form.spinner().stop();
	                }
	            });
	            return false;
	        });
	    },

	    emailValidationLogin: function emailValidationLogin() {
	        $(document).on('click', '.js-email-login-validation', function () {
	            validateEmail($('#login-form-email'));
	        });
	    },

	    clearResetForm: function clearResetForm() {
	        $('#login .modal').on('hidden.bs.modal', function () {
	            $('#reset-password-email').val('');
	            $('.modal-dialog .form-control.is-invalid').removeClass('is-invalid');
	        });
	    },

	    validate: function validate() {
	        $('#login-form-email').on('blur', function () {
	            var fieldValue = $(this).val().trim();
	            $(this).val(fieldValue);
	            var isEmailField = $(this)[0].type === 'email' ? true : false;
	            if (fieldValue.length > 0) {
	                // check if a number is entered
	                var numberRegex = /^\+?[\d ]+$/;
	                var isPhoneNumber = numberRegex.test(fieldValue);
	                if (isPhoneNumber && !isEmailField) {
	                    var isValid = validatePhone(this);

	                    // Check for phone customer if phone format is valid
	                    if (isValid) {
	                        var isCheckoutModal = $('#checkoutLoginModal').length > 0;
	                        var loginSource = isCheckoutModal ? 'checkout' : 'login';

	                        $.ajax({
	                            url: $('.js-check-phone-registration').data('action'),
	                            type: 'POST',
	                            data: { phone: fieldValue, loginSource: loginSource },
	                            success: function (data) {
	                                if (data.requiresCompleteRegistration) {
	                                    if (data.notificationTemplate && loginSource === 'login') {
	                                        showCompleteRegistrationRedirectNotification(data);
	                                    } else {
	                                        openCompleteRegistrationModal(data);
	                                    }
	                                }
	                            }.bind(this)
	                        });
	                    }
	                } else {
	                    validateEmail(this);
	                }
	            } else {
	                $(this).addClass('is-invalid');
	                $(this).parents('.cc-form-group').find('.cc-text-message').text($(this).data('missing-error'));
	            }
	        });
	    }
	};

/***/ }),

/***/ 172:
/***/ (function(module, exports) {

	'use strict';

	module.exports = function () {
	    // Initialize tabindex and aria-label to password toggle icons
	    $('.js-togglePassword').each(function () {
	        var $icon = $(this);
	        var $passwordContainer = $icon.closest('.cc-content-input-password');
	        var showLabel = $passwordContainer.data('show-password-label');
	        var hideLabel = $passwordContainer.data('hide-password-label');

	        $icon.attr('tabindex', '0');
	        $icon.attr('role', 'button');

	        if ($icon.hasClass('js-hide')) {
	            $icon.attr('aria-label', showLabel);
	        } else {
	            $icon.attr('aria-label', hideLabel);
	        }
	    });

	    $(document).off('click', '.js-togglePassword').on('click', '.js-togglePassword', function () {
	        var self = $(this);
	        self.parent().find('.js-form-password').attr('type', self.parent().find('.js-form-password').is(':password') ? 'text' : 'password');
	        if (self.parent().find('.js-form-password').attr('type') === 'password') {
	            self.closest('.cc-content-input').removeClass('js-passwordShow cc-account__viewPassword');
	        } else {
	            self.closest('.cc-content-input').addClass('js-passwordShow cc-account__viewPassword');
	            setTimeout(function () {
	                if (self.closest('.cc-content-input').hasClass('js-passwordShow cc-account__viewPassword')) {
	                    self.click();
	                    self.closest('.cc-content-input').removeClass('js-passwordShow cc-account__viewPassword');
	                }
	            }, 5000);
	        }
	    });

	    // Keyboard accessibility: Handle Enter and Space key presses
	    $('body').on('keydown', '.js-togglePassword', function (e) {
	        // Handling special-case Space and Spacebar
	        if (e.key === 'Enter' || e.key === 'Spacebar' || e.key === ' ' || e.key === 'Space') {
	            e.preventDefault();
	            $(this).trigger('click');
	        }
	    });
	};

/***/ }),

/***/ 173:
/***/ (function(module, exports) {

	'use strict';

	/**
	 * Announces field status to screen readers when user completes filling a field
	 */

	module.exports = function () {
	    var $announcementRegion = $('.js-field-status-announcement');
	    var $loginForm = $('form[name="login-form"]');

	    if (!$announcementRegion.length || !$loginForm.length) {
	        return;
	    }

	    // Get localized messages from data attributes
	    var filledMessage = $loginForm.data('aria-filled');
	    var emptyMessage = $loginForm.data('aria-empty');

	    /**
	     * Listen to blur events for email, text, and password
	     */
	    $loginForm.on('blur', 'input[type="email"], input[type="text"], input[type="password"]', function () {
	        var $input = $(this);
	        var fieldLabel = $input.attr('aria-label') || $input.attr('placeholder');
	        var fieldValue = $input.val().trim();
	        // Clear any previous announcements
	        $announcementRegion.text('');

	        // Small delay ensures screen reader picks up the change
	        setTimeout(function () {
	            if (fieldValue) {
	                // Announce that the field has been filled
	                $announcementRegion.text(fieldLabel + ' ' + filledMessage);
	            } else {
	                // Announce that the field is empty
	                $announcementRegion.text(fieldLabel + ' ' + emptyMessage);
	            }
	        }, 100);
	    });

	    /**
	     * Clear announcements when user focuses on a new field
	     * This prevents old announcements from persisting
	     */
	    $loginForm.on('focus', 'input[type="email"], input[type="text"], input[type="password"]', function () {
	        setTimeout(function () {
	            // Clear announcement after 2 seconds
	            $announcementRegion.text('');
	        }, 2000);
	    });

	    /**
	     * Handle Enter key on Remember Me checkbox to toggle instead of submitting form
	     */
	    $loginForm.on('keydown', '#rememberMe', function (e) {
	        if (e.key === 'Enter' || e.keyCode === 13) {
	            e.preventDefault();
	            // Toggle the checkbox
	            this.checked = !this.checked;
	        }
	    });
	};

/***/ })

/******/ });